import React, {useEffect, useState} from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import ApplicantView from './ApplicantView'
import axiosInstance from '../../../api/axiosInstance'
import { useDispatch } from 'react-redux'
import { removeData } from '../../../Redux/Feature/AdminSlice'

function ViewUser() {
    const {id} = useParams()
    const [applicant, setApplicant] = useState({})
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const fetchData = async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}get-paiduser-by-id/${id}`)
            console.log(response) 
            setApplicant(response.data)
        } catch (error) {
            console.log(error)
            if(error.response.status === 401 || error.response.status === 403){
                navigate('/Admin/login')
                dispatch(removeData())
            }
        }
    }

    useEffect(() => {
        fetchData()
    }, [id])
  

  return (
    <ApplicantView data={applicant}/>
  )
}

export default ViewUser